import store from "../store";
import moment from "moment";
import _ from "lodash";
import { merge } from "lodash";

export default class Currencies {
  monedaDefault = "";
  constructor() {
    this.setDefaultCurrency();
  }

  async setDefaultCurrency(currency = null) {
    this.monedaDefault = currency
      ? currency
      : await Currencies.getCurrencyDefault();
  }

  static getCurrencyDefault() {
    const tipoCambio = store.getters["getTiposCambios"];
    if (tipoCambio[0]) {
      return tipoCambio[0].Default;
    }
    return {};
  }

  static getPagos() {
    return store.getters["getPDVPagosTipos"];
  }

  static getCurrencies() {
    return store.getters["getPDVMonedasLista"];
  }

  static getExchangeRate(byDate = null) {
    const tipoCambio = store.getters["getTiposCambios"];
    if (byDate) {
      let selectedTipoCambio = null;
      let orderedTc = _.orderBy(tipoCambio, ["Momento"], ["asc"]);
      orderedTc.reverse().forEach((tc) => {
        if (moment(tc.FechaCreacion).format("YYYY-MM-DD HH:mm") <= byDate) {
          selectedTipoCambio = tc;
        }
      });
      return selectedTipoCambio;
    }

    return tipoCambio[0];
  }

  static getExchangeRateByCurrency(amount, from, to, date = null) {
    let exchange = amount;
    let tiposCambio = Currencies.getExchangeRate(date);
    if (from == Currencies.getCurrencyDefault()) {
      exchange = amount / tiposCambio.TC[to];
    } else {
      let defaultExchange = tiposCambio.TC[from] * amount;
      if (to == Currencies.getCurrencyDefault()) {
        exchange = defaultExchange;
      } else {
        exchange = Currencies.getExchangeRateByCurrency(
          defaultExchange,
          Currencies.getCurrencyDefault(),
          to
        );
      }
    }

    if (from == to) {
      exchange = amount;
    }

    return Number.isNaN(exchange) ? 0 : parseFloat(exchange);
  }
}
